import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

// Fullscreen in-app image viewer (no new tab). images: string[]; index: starting index.
export const ImageLightbox = ({ images = [], index = 0, onClose }) => {
  const [i, setI] = useState(index);
  useEffect(() => setI(index), [index]);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setI((v) => (v + 1) % images.length);
      if (e.key === "ArrowLeft") setI((v) => (v - 1 + images.length) % images.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [images.length, onClose]);

  if (!images.length) return null;
  const many = images.length > 1;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[10000] bg-black/95 flex items-center justify-center" onClick={(e) => { e.stopPropagation(); onClose(); }} data-testid="image-lightbox" style={{ paddingTop: "env(safe-area-inset-top)", paddingBottom: "env(safe-area-inset-bottom)" }}>
      <button onClick={(e) => { e.stopPropagation(); onClose(); }} className="absolute top-3 right-3 p-2.5 rounded-full bg-white/15 text-white hover:bg-white/25" style={{ top: "calc(env(safe-area-inset-top) + 12px)" }} aria-label="Close" data-testid="image-lightbox-close">
        <X className="w-6 h-6" />
      </button>
      {many && (
        <>
          <button onClick={(e) => { e.stopPropagation(); setI((v) => (v - 1 + images.length) % images.length); }} className="absolute left-2 top-1/2 -translate-y-1/2 p-2.5 rounded-full bg-white/15 text-white hover:bg-white/25" aria-label="Previous" data-testid="image-lightbox-prev"><ChevronLeft className="w-6 h-6" /></button>
          <button onClick={(e) => { e.stopPropagation(); setI((v) => (v + 1) % images.length); }} className="absolute right-2 top-1/2 -translate-y-1/2 p-2.5 rounded-full bg-white/15 text-white hover:bg-white/25" aria-label="Next" data-testid="image-lightbox-next"><ChevronRight className="w-6 h-6" /></button>
          <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/70 text-sm" data-testid="image-lightbox-counter">{i + 1} / {images.length}</p>
        </>
      )}
      <img src={images[i]} alt={`Photo ${i + 1}`} className="max-w-[95vw] max-h-[85vh] object-contain rounded-lg shadow-2xl select-none" onClick={(e) => e.stopPropagation()} draggable={false} data-testid="image-lightbox-img" />
    </div>,
    document.body
  );
};
